<template>
  <v-sheet
    v-bind="$attrs"
    color="white"
    width="100%"
    elevation="0"
    class="pa-3 text-start v-card--material__heading mb-n6"
    
  >
    <div class="ml-auto text-center">
      <div class="body-3 font-weight-light" :style="textColour" v-if="title" v-text="title"></div>
      <h3 class="display-3 font-weight-light" :style="textColour" v-text="text" v-if="text">
      </h3>
      <span v-text="footer" :style="textColour" v-if="footer"></span>
    </div>
  </v-sheet>
</template>
<script>
  export default {
    name: 'Stat',
    props: {
      color: {
        type: String,
        default: 'primary',
      },
      title: {
        type: String,
        default: '',
      },
      text: {
        type: String,
        default: '',
      },
      footer: {
        type: String,
        default: '',
      },
    },
    computed: {
      textColour() {
        return `color: ${this.color}`
      }
    }
  }
  </script>